import React from "react";
import Video from "../../main/Video";
import BackButton from "../../main/BackButton";

const MusicVideo = () => {
  return (
    <>
      <BackButton url="/allvideos" />
      <Video
        url={`https://yuriy-dmytrash19.wistia.com/medias/ptmiaqqryz`}
        maxHeight="80%"
      />
    </>
  );
};

export default MusicVideo;
